export default __webpack_public_path__ + "static/media/phone.e55fdfa0.png";